import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const DeleteOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M10.49 9.98c-.39 0-.7.31-.7.7v5.14c0 .39.31.7.7.7.39 0 .7-.31.7-.7v-5.14c0-.39-.31-.7-.7-.7ZM13.51 9.95c-.39 0-.7.31-.7.7v5.14c0 .39.31.7.7.7.39 0 .7-.31.7-.7v-5.14c0-.39-.31-.7-.7-.7Z" />
      <Path d="M19.5 5.45h-3.45l-.42-1.11a2.099 2.099 0 0 0-1.95-1.35h-3.46c-.86 0-1.65.54-1.95 1.35l-.42 1.11H4.51c-.4 0-.73.33-.73.73 0 .4.33.73.73.73h1.11c-.01.1-.01.21 0 .32l1.32 12.33c.09.82.81 1.44 1.67 1.44h6.78c.86 0 1.58-.62 1.67-1.44l1.32-12.33c.01-.11 0-.21 0-.32h1.11c.4 0 .73-.33.73-.73 0-.4-.33-.73-.73-.73h.01Zm-9.87-.59c.09-.24.33-.4.59-.4h3.46c.26 0 .49.16.59.4l.22.59H9.41l.22-.59Zm5.98 14.54c0 .06-.1.14-.22.14H8.61c-.12 0-.21-.07-.22-.14L7.07 7.07s0-.04.03-.08c.03-.03.08-.07.19-.07h9.43c.1 0 .16.05.19.07.04.04.03.07.03.08L15.62 19.4h-.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default DeleteOutlined
